export default {
  overrideProportionalResize: true,
};
